ACC.account = {

	bindAll : function() {
		ACC.account.bindToShowConfirmChangeEmailInput();
		ACC.account.bindChangeDateSelectInput();
		
		
	},

	bindToShowConfirmChangeEmailInput : function() {
		$('.control-hide').keydown( function(){
			$('.control-hideable').each(function(index){
				$(this).parent().slideDown();
			})
		});
		$('.control-hide-login').keydown( function(){
			$('.control-label-login').each(function(index){
				$(this).parent().slideDown();
			})
		});
	},
	bindChangeDateSelectInput : function() {
		$('select#Year').change(ACC.account.changeDateSelectInput);
		$('select#Month').change(ACC.account.changeDateSelectInput);
	},
	changeDateSelectInput : function() {
		if($('select#Year').val() && $('select#Month').val()){
			$.ajax({
			url: this.getAttribute('data-ajax'),
			cache: false,
			data:{year: $('select#Year').val(), month : $('select#Month').val()},
			type: 'GET'
            }).done(function (result)
			{
				var selectedIndex = $('select#Day')[0].selectedIndex;
				$('select#Day').children().remove(":not(option:disabled)")
				$.each(result, function(i, item) {
				    $("select#Day").append(new Option(item.code, item.name));
				});
				if ($('select#Day').children().length>selectedIndex){
					$('select#Day')[0].selectedIndex = selectedIndex;
				}
		});
	}
}}

$(document).ready(function() {
	ACC.account.bindAll();
});
